import { useField } from 'formik';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const currentYear = dayjs();

// Fully clean TextField (your unchanged style)
const CustomTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    paddingRight: '40px',
    backgroundColor: '#fff',
    height: '20px',
  },
  '& fieldset': {
    border: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& input': {
    padding: '10px 12px',
  },
  '& .MuiIconButton-root': {
    position: 'absolute',
    right: '8px',
  },
  '& .MuiInputAdornment-root': {
    marginRight: 0,
  }
});

export default function DatePickerYearsOrder({ name,status }) {
  const [field, meta, helpers] = useField(name);

  return (
    <div className="form-control">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={field.value ? dayjs(`${field.value}`, 'YYYY') : null}
          onChange={(newValue) => {
            if (newValue) {
              helpers.setValue(newValue.year()); // only save year
            } else {
              helpers.setValue('');
            }
          }}
          maxDate={currentYear}
          openTo="year"
          views={['year']}
          yearsOrder="desc"
          format="YYYY"
          enableAccessibleFieldDOMStructure={false}
          disabled={status === 'approved'}
          slots={{
            textField: (params) => (
              <CustomTextField
                {...params}
                fullWidth
                placeholder=""
                error={Boolean(meta.touched && meta.error)}
                helperText={meta.touched && meta.error}
              />
            )
          }}
        />
      </LocalizationProvider>
    </div>
  );
}
